// Prévia da mensagem agendada: troca as variáveis ({{firstName}}, {{name}}...)
// pelos dados do contato, como o backend faz no envio. As variáveis de
// horário usam o horário agendado (o backend usa o horário real do envio).

const pad = (n) => String(n).padStart(2, "0");

export const greetingFor = (hour) => {
  if (hour < 6) return "Boa madrugada";
  if (hour < 12) return "Bom dia";
  if (hour < 18) return "Boa tarde";
  return "Boa noite";
};

export const previewBody = (body, contact, when) => {
  if (!body) return "";
  const d = when ? new Date(when) : new Date();
  const valid = !Number.isNaN(d.getTime());
  const date = valid ? d : new Date();
  const hh = date.getHours();
  const name = contact?.name || "";
  const hour = `${hh}:${pad(date.getMinutes())}`;
  const values = {
    firstName: name.split(" ")[0] || "",
    name,
    gretting: greetingFor(hh),
    ms: greetingFor(hh),
    hora: hour,
    hour,
    date: `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`,
    protocol: "",
  };
  return body.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) =>
    key in values ? values[key] : match
  );
};
